<template>
    <b-table
        :data="missingCp303"
        :hoverable="true"
        :loading="loading">
        <template slot-scope="props">
            <b-table-column label="Produkt">
                {{ props.row }}
            </b-table-column>
        </template>
    </b-table>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    computed: mapGetters('missingmappings', ['missingCp303', 'loading'])
}
</script>

<style>

</style>
